import { Icon } from "@minervaproject/fds";
import { forwardRef } from "react";

import { IconPropsType } from "shared/types";

export const ConnectionIssueIcon = forwardRef<HTMLElement, IconPropsType>((props, ref) => (
  <Icon width={16} height={16} {...props} ref={ref}>
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.03066 2.49483C4.98659 1.95912 5.40949 1.5 5.94702 1.5H5.99131C6.52883 1.5 6.95173 1.95912 6.90766 2.49483L6.52622 7.13145C6.50237 7.4214 6.26009 7.64457 5.96916 7.64457C5.67823 7.64457 5.43595 7.4214 5.4121 7.13145L5.03066 2.49483Z"
        fill={props?.color || "#F2F2F2"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.95964 10.4992C6.46629 10.4992 6.87701 10.074 6.87701 9.5494C6.87701 9.02485 6.46629 8.59961 5.95964 8.59961C5.45299 8.59961 5.04227 9.02485 5.04227 9.5494C5.04227 10.074 5.45299 10.4992 5.95964 10.4992Z"
        fill={props?.color || "#F2F2F2"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.82761 4.53071C7.82761 4.53071 9.61554 4.99592 10.5516 6.09109C10.7482 5.90694 11.3286 5.31575 11.3286 5.31575C11.3286 5.31575 9.92445 3.83291 7.90249 3.43555C7.87441 4.00736 7.82761 4.53071 7.82761 4.53071Z"
        fill={props?.color || "#F2F2F2"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74241 6.03125C7.72368 6.51584 7.67688 7.17488 7.67688 7.17488C7.67688 7.17488 8.50064 7.52378 8.80019 7.93083C9.1091 7.6207 9.55843 7.15549 9.55843 7.15549C9.55843 7.15549 8.80019 6.33169 7.74241 6.03125Z"
        fill={props?.color || "#F2F2F2"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25098 4.53071C4.25098 4.53071 2.46304 4.99592 1.52695 6.09109C1.33037 5.90694 0.749994 5.31575 0.749994 5.31575C0.749994 5.31575 2.15413 3.83291 4.17609 3.43555C4.20417 4.00736 4.25098 4.53071 4.25098 4.53071Z"
        fill={props?.color || "#F2F2F2"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19451 6.03125C4.21324 6.51584 4.26004 7.17488 4.26004 7.17488C4.26004 7.17488 3.43628 7.52378 3.13673 7.93083C2.82782 7.6207 2.3785 7.15549 2.3785 7.15549C2.3785 7.15549 3.13673 6.33169 4.19451 6.03125Z"
        fill={props?.color || "#F2F2F2"}
      />
    </svg>
  </Icon>
));
